import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {getCorAleatoria} from "../../../utils/functions";
import {ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList} from 'recharts';
import PropTypes from "prop-types";
import _ from 'lodash';

@inject("store")
@observer
export class CustomBarChart extends Component {
    static propTypes = {
        data: PropTypes.PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.arrayOf(PropTypes.object)
        ]),
        dataKeys: PropTypes.arrayOf(PropTypes.string),
        onClick: PropTypes.func,
        stackId: PropTypes.string,
        legend: PropTypes.bool,
        labelStraight: PropTypes.bool,
        labelAxisX: PropTypes.string,
        labelAxisY: PropTypes.string,
        tooltipFormatter: PropTypes.func,
        customColor: PropTypes.func
    };

    static defaultProps = {
        width: 600,
        height: 300,
        dataKeys: [],
        legend: true,
        labelStraight: false,
        customColor: null
    };

    constructor(props) {
        super(props);
    }

    showChart = () => {
        return this.props.data && this.props.data.length > 0;
    }

    showNoDataFound = () => {
        return this.props.data && this.props.data.length === 0;
    }

    calculatefontSize = (data) => {
        if(!data) {
            return "0.8rem";
        }

        const length = _.max(_.map(data, d => d.nome.length));

        if(length <= 22) {
            return "0.8rem";
        } else if(length <= 25) {
            return "0.7rem";
        } else {
            return "0.6rem";
        }
    }

    renderCustomizedLabel = (props) => {
        const {
            x, y, width, height, value,
        } = props;
        const radius = 10;

        return value ? (
            <g>
                <rect x={x + width / 2 - 15} y={y - 17 / 2 - 13} width={30} height={17} rx="3" fill="#888c96" />
                <text x={x + width / 2} y={y - 17 / 2 - 4} fill="#fff" textAnchor="middle" dominantBaseline="middle">
                    {value}
                </text>
            </g>
        ) : null;
    };

    render() {
        const props = {
            barChart: {
                data: this.props.data,
                width: this.props.width,
                height: this.props.height
            },
            bar: {
                onClick: this.props.onClick,
                stackId: this.props.stackId
            },
            xAxis: {
                label: {
                    value: this.props.labelAxisX,
                    position: "insideRight"
                }
            },
            yAxis: {
                label: {
                    value: this.props.labelAxisY,
                    position: "insideLeft",
                    angle: -90
                },
                padding:{ top: 25 }
            },
            xAxisRotate: {
                height: 130,
                interval: 0
            },
            xAxisTick: {
                fontSize: this.calculatefontSize(this.props.data)
            },
            tooltip: {
                formatter: this.props.tooltipFormatter
            }
        };

        return (
            <div>
                { this.showChart() &&
                    <div className="container-graph">
                        <ResponsiveContainer>
                            <BarChart { ...props.barChart }>
                                { this.props.labelStraight &&
                                    <XAxis dataKey="nome" { ...props.xAxis } />
                                }
                                { !this.props.labelStraight &&
                                    <XAxis dataKey="nome" { ...props.xAxis } { ...props.xAxisRotate } tick={<CustomizedAxisTick { ...props.xAxisTick } />} />
                                }
                                <YAxis { ...props.yAxis } />
                                <CartesianGrid strokeDasharray="3 3"/>
                                <Tooltip { ...props.tooltip }/>
                                { this.props.legend &&
                                    <Legend />
                                }
                                { this.props.dataKeys.map((dataKey, index) => {
                                        return <Bar { ...props.bar } dataKey={dataKey} key={dataKey} fill={this.props.customColor ? this.props.customColor(index) : getCorAleatoria(index)} >
                                            <LabelList
                                                fill="#000"
                                                position="top"
                                                valueAccessor={(entry) => (index === this.props.dataKeys.length - 1 ? entry.value[1] : null)}
                                                content={this.renderCustomizedLabel}
                                            />
                                        </Bar>
                                    })
                                }
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                }
                { this.showNoDataFound() &&
                    <span>Nenhum resultado encontrado</span>
                }
            </div>
        )
    }
}

const CustomizedAxisTick = React.createClass({
    render() {
        const {x, y, stroke, payload, fontSize} = this.props;

        return (
            <g transform={`translate(${x},${y})`}>
                <text x={0} y={0} dy={16} textAnchor="end" fill="#666"
                        fontSize={fontSize} transform="rotate(-35)"
                >
                    <title>{payload.value}</title>
                    {
                        _.truncate(payload.value, {
                            'length': 30
                        })
                    }
                </text>
            </g>
        );
    }
});

BarChart.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ])
}
